import React from "react";
import { useLocation } from "react-router-dom";
import { parseQueryParams } from "utils/common";

export const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => parseQueryParams(search), [search]);
};
